'use client';

import React from 'react';
import { Mail, MessageCircle } from 'lucide-react';

export const FloatingContacts: React.FC = () => {
    const whatsappNumber = process.env.NEXT_PUBLIC_WHATSAPP_NUMBER || '4917012345678';
    const email = process.env.NEXT_PUBLIC_EMAIL || 'info@gemp-consulting.com';
    const whatsappDigits = whatsappNumber.replace(/[^\d]/g, '');

    const handleWhatsApp = () => {
        if (!whatsappDigits) return;
        window.location.href = `https://wa.me/${whatsappDigits}`;
    };

    const handleEmail = () => {
        window.location.href = `mailto:${email}`;
    };

    return (
        <div className="floating-contacts">
            <button
                className="floating-btn floating-whatsapp"
                onClick={handleWhatsApp}
                aria-label="Contact us on WhatsApp"
                title="WhatsApp"
            >
                <MessageCircle size={24} />
            </button>
            <button
                className="floating-btn floating-email"
                onClick={handleEmail}
                aria-label="Send us an email"
                title="Email"
            >
                <Mail size={24} />
            </button>
        </div>
    );
};
